module.exports = __webpack_public_path__ + "static/media/introduction-recibase_04.910b3a5e.jpg";